export default {
  eyebrow: 'Partnerportal',
  title: 'Konto',
  description: 'Dine partnerkontooplysninger.',
  page: {
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier.',
    editing_notice: 'Redigerer — ændringer er synlige for dit team og dine kunder.',
  },
  profile: {
    form: {
      name: {
        label: 'Partnernavn',
        hint: 'Det juridiske navn / enhedsnavn. Bruges på faktureringsdokumenter.',
      },
      display_name: {
        label: 'Visningsnavn for forbrugere',
        hint: 'Etiketten „Powered by ___“, som dine kunder ser på tværs af dine restauranter. Er som standard partnernavnet, hvis det lades stå tomt.',
      },
      support_email: {
        label: 'Kontakt-e-mail',
        hint: 'Hvor FoodAmigos og dine kunder kan kontakte dig. Din login-e-mail forbliver uændret.',
      },
      invoicing_emails: {
        label: 'Faktura-e-mails',
        hint: 'Kvitteringer for fakturaer, der faktureres til dig, sendes til hver af disse adresser. Lad feltet stå tomt for at bruge din login-e-mail.',
        placeholder: 'Din login-e-mail',
      },
    },
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  toasts: {
    load_error: 'Dine kontooplysninger kunne ikke indlæses.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
